import { useState } from "react";
import {
  NavLink,
  Outlet,
  useNavigate,
} from "react-router-dom";
import {
  CalendarCheck,
  Calendar2Week,
  CalendarPlus,
  List,
  X,
  GearFill,
  BoxArrowRight,
} from "react-bootstrap-icons";

import { ProjectName } from "../constants/ProjectName";
import { useAuthContext } from "../hooks/useAuthContext";
import "./ClientLayout.css";

const logo = "/logo192.png";

export default function ClientLayout({ profile }) {
  const navigate = useNavigate();
  const { dispatch } = useAuthContext();

  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => {
    setMenuOpen(false);
  };

  const logout = () => {
    dispatch({
      type: "LOGOUT",
      payload: {},
    });

    closeMenu();
    navigate("/");
  };

  return (
    <div className="client-app">
      <header className="client-mobile-header">
        <div className="client-mobile-brand">
          <div className="client-logo">
            <img src={logo} alt={`${ProjectName} logo`} />
          </div>

          <div>
            <strong>{ProjectName}</strong>
            <span>Client Portal</span>
          </div>
        </div>

        <button
          type="button"
          className="client-menu-button"
          onClick={() => setMenuOpen((current) => !current)}
          aria-label={menuOpen ? "Close navigation menu" : "Open navigation menu"}
          aria-expanded={menuOpen}
        >
          {menuOpen ? <X /> : <List />}
        </button>
      </header>

      {menuOpen && (
        <button
          type="button"
          className="client-sidebar-overlay"
          onClick={closeMenu}
          aria-label="Close navigation menu"
        />
      )}

      <aside
        className={`client-sidebar ${
          menuOpen ? "client-sidebar-open" : ""
        }`}
      >
        <div>
          <div className="client-brand">
            <div className="client-logo">
              <img src={logo} alt={`${ProjectName} logo`} />
            </div>

            <div>
              <strong>{ProjectName}</strong>
              <span>Client Portal</span>
            </div>

            <button
              type="button"
              className="client-sidebar-close"
              onClick={closeMenu}
              aria-label="Close navigation menu"
            >
              <X />
            </button>
          </div>

          <nav className="client-nav">
            <NavLink to="/dashboard" onClick={closeMenu}>
              <CalendarCheck />
              Dashboard
            </NavLink>

            <NavLink to="/appointments" onClick={closeMenu}>
              <Calendar2Week />
              Appointments
            </NavLink>

            {profile?.canSelfBookAppointments && (
              <NavLink to="/bookAppointment" onClick={closeMenu}>
                <CalendarPlus />
                Book appointment
              </NavLink>
            )}

            <NavLink to="/settings" onClick={closeMenu}>
              <GearFill />
              Settings
            </NavLink>
          </nav>
        </div>

        <div className="client-sidebar-bottom">
          <div className="client-sidebar-footer">
            <div className="client-avatar">
              {profile?.firstName?.[0]?.toUpperCase() || "C"}
            </div>

            <div>
              <strong>
                {profile?.firstName} {profile?.lastName}
              </strong>
              <span>Client</span>
            </div>
          </div>

          <button
            type="button"
            className="client-logout-button"
            onClick={logout}
          >
            <BoxArrowRight />
            <span>Logout</span>
          </button>
        </div>
      </aside>

      <main className="client-main">
        <Outlet />
      </main>
    </div>
  );
}